import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { "data-cy": "email-icon-selected", "data-testid": "email-icon-selected", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeWidth: 1.5 }, /* @__PURE__ */ React.createElement("path", { d: "m9 12-6.358 6.331m18.776.077L15 12m6-6-8.336 7.41a1 1 0 0 1-1.328 0L3 6" }), /* @__PURE__ */ React.createElement("path", { d: "M4 19h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" })));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
